import { User } from 'lucide-react'
import type { AgentAttachment } from '@/services/agent/service'

type Props = {
    content: string
    attachments?: AgentAttachment[]
}

export default function UserMessage({ content, attachments }: Props) {
    const labelFor = (a: AgentAttachment) => {
        switch (a.kind) {
            case 'document':
                return 'Doc'
            case 'foundation_run':
                return 'Foundation'
            case 'communication_brief':
                return 'Brief'
            case 'heft_profile':
                return 'Profile'
            case 'heft_story':
                return 'Story'
        }
        return 'Attachment'
    }

    const titleFor = (a: AgentAttachment) => {
        if (a.kind === 'heft_story') return a.title || a.id
        return (a as any).name || a.id
    }

    return (
        <div className='flex justify-end gap-3'>
            <div className='max-w-[85%]'>
                {attachments && attachments.length > 0 ? (
                    <div className='mb-1 flex flex-wrap justify-end gap-1.5'>
                        {attachments.map((a, idx) => (
                            <span
                                key={`${a.kind}-${a.id}-${idx}`}
                                className='inline-flex items-center rounded-full bg-white px-2 py-0.5 text-[11px] font-medium text-slate-700 ring-1 ring-slate-200'
                                title={a.kind}
                            >
                                {labelFor(a)}
                                <span className='mx-1 text-slate-300'>·</span>
                                <span className='max-w-[180px] truncate'>{titleFor(a)}</span>
                            </span>
                        ))}
                    </div>
                ) : null}
                <div className='inline-block w-full rounded-2xl rounded-tr-md bg-primary-main px-3.5 py-2 text-sm text-white whitespace-pre-wrap'>
                    {content}
                </div>
            </div>
            <div className='flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-slate-200'>
                <User className='h-3.5 w-3.5 text-slate-600' />
            </div>
        </div>
    )
}
